import { useMemo } from 'react'
import { usePublicClient, useWalletClient } from 'wagmi'
import { publicClientToProvider, walletClientToSigner } from 'utils/wagmiEthersAdapters'
import { useActiveChainId } from './useActiveChainId'

export const useProviderOrSigner = (withSignerIfPossible = true) => {
  const { chainId } = useActiveChainId()
  const publicClient = usePublicClient({ chainId })
  const { data: walletClient } = useWalletClient({ chainId })

  return useMemo(() => {
    if (withSignerIfPossible && walletClient) {
      return walletClientToSigner(walletClient)
    }
    if (publicClient) {
      return publicClientToProvider(publicClient)
    }
    return null
  }, [publicClient, walletClient, withSignerIfPossible])
}
